export default __webpack_public_path__ + "static/media/insuranceFlow.ba844cab.svg";